import { Upload, FileSpreadsheet, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CrystalBallUploadProps {
  onUpload: () => void;
  isUploaded: boolean;
}

export default function CrystalBallUpload({ onUpload, isUploaded }: CrystalBallUploadProps) {
  return (
    <section className="relative py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-crystal-purple/20 text-crystal-purple mb-4">
            <span className="text-xl font-bold">1</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            Upload Your Production Data
          </h2>
          <p className="text-medium-gray">
            Upload a CSV file with your production line sensor data for AI analysis
          </p>
        </div>

        <div
          className={`relative rounded-2xl border-2 border-dashed transition-all duration-500 p-12 text-center cursor-pointer group ${
            isUploaded
              ? "border-crystal-success/50 bg-crystal-success/5"
              : "border-crystal-purple/30 bg-crystal-card hover:border-crystal-purple/60 hover:bg-crystal-card-hover"
          }`}
          onClick={!isUploaded ? onUpload : undefined}
        >
          {isUploaded ? (
            <div className="animate-fade-in">
              <CheckCircle className="w-16 h-16 text-crystal-success mx-auto mb-4" />
              <p className="text-xl font-semibold text-foreground mb-1">
                production_data_2025.csv
              </p>
              <p className="text-medium-gray">
                2,847 records • 14 sensor columns • 3 production lines
              </p>
            </div>
          ) : (
            <>
              <div className="relative">
                <Upload className="w-16 h-16 text-crystal-purple/60 mx-auto mb-4 group-hover:text-crystal-purple transition-colors" />
              </div>
              <p className="text-lg font-semibold text-foreground mb-2">
                Drop your CSV file here or click to browse
              </p>
              <p className="text-medium-gray mb-6 text-sm">
                Supports .csv, .xlsx formats • Max 50MB
              </p>
              <Button
                className="bg-gradient-to-r from-crystal-purple to-crystal-blue hover:opacity-90 text-foreground font-semibold px-8"
                onClick={(e) => {
                  e.stopPropagation();
                  onUpload();
                }}
              >
                <FileSpreadsheet className="w-4 h-4 mr-2" />
                Try with Sample Data
              </Button>
              <p className="text-xs text-medium-gray mt-3">
                Use our sample manufacturing dataset to see the demo
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
